/** CPF (11 digits) and CNPJ (14 positions - numeric or alphanumeric). */

export function sanitizeDocumentInput(value: string): string {
  return value.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 14)
}

function formatCpf(digits: string): string {
  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2")
}

function applyCnpjMask(raw: string): string {
  if (/^\d{14}$/.test(raw)) {
    return raw
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2")
  }

  return raw
    .replace(/^([0-9A-Z]{2})([0-9A-Z])/, "$1.$2")
    .replace(/^([0-9A-Z]{2}\.[0-9A-Z]{3})([0-9A-Z])/, "$1.$2")
    .replace(/\.([0-9A-Z]{3})([0-9A-Z])/, ".$1/$2")
    .replace(/(\/[0-9A-Z]{4})(\d{1,2})$/, "$1-$2")
}

export function formatCpfCnpj(value: string): string {
  const raw = sanitizeDocumentInput(value)
  if (!raw) return ""

  const isCnpj = /[A-Z]/.test(raw) || raw.length > 11
  if (!isCnpj) return formatCpf(raw)

  return applyCnpjMask(raw)
}

export function formatCnpj(value: string): string {
  const raw = sanitizeDocumentInput(value)
  if (!raw) return ""
  return applyCnpjMask(raw)
}
